import { useTheme } from '@mui/material/styles';
import { brandColors } from '../../theme';
import { styleConstants } from '../../Utils/styleConsts';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                gap: theme.spacing(2),
            },
        },
        settings: {
            width: `calc(25% - ${theme.spacing(2)})`,
            borderRadius: styleConstants.borderRadius,
            border: `2px solid ${brandColors.main}`,
            display: 'flex',
            flexDirection: 'column',
            padding: theme.spacing(2),
            textDecoration: 'none',
            color: theme.palette.primary.dark,
            backgroundColor: theme.palette.background.paper,
            [theme.breakpoints.down('lg')]: {
                width: `calc(50% - ${theme.spacing(2)})`,
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
        caption: {
            marginTop: theme.spacing(1),
        },
        options: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: theme.spacing(2),
            width: '75%',
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
            '& > *': {
                [theme.breakpoints.up('lg')]: {
                    width: `calc(33.33% - ${theme.spacing(1.5)})`,
                },
                [theme.breakpoints.between('sm', 'lg')]: {
                    width: `calc(50% - ${theme.spacing(1.5)})`,
                },
                [theme.breakpoints.down('sm')]: {
                    width: `100%`,
                    justifyContent: 'flex-start',
                },
            },
        },
        switch: {
            marginRight: theme.spacing(1),
        },
        emptyStorage: {
            marginTop: theme.spacing(1.5),
            textTransform: styleConstants.buttonTextTransform,
            fontWeight: styleConstants.buttonFontWeight,
        },
        expiring: {
            borderRadius: theme.shape.borderRadius,
            backgroundColor: theme.palette.primary.main,
            marginTop: theme.spacing(2),
            padding: theme.spacing(1.5),
            color: theme.palette.common.white,
            display: 'flex',
        },
        icon: {
            marginRight: theme.spacing(1),
        },
        bold: {
            fontWeight: 900,
        },
        box: {
            marginBottom: theme.spacing(2),
        },
        header: {
            fontWeight: 900,
            marginBottom: theme.spacing(0.5),
            color: theme.palette.primary.main,
        },
        googleMaps: {
            border: 'none',
            maxHeight: '15rem',
            display: 'flex',
            borderRadius: theme.shape.borderRadius,
            marginBottom: theme.spacing(2),
        },
        title: {
            color: theme.palette.primary.dark,
            paddingBottom: '0.25rem',
            [theme.breakpoints.down('sm')]: {
                fontSize: '1.5rem',
            },
        },
        button: {
            textTransform: styleConstants.buttonTextTransform,
            fontSize: styleConstants.buttonFontSize,
            fontWeight: styleConstants.buttonFontWeight,
            padding: styleConstants.buttonPadding,
        },
        dialogActions: {
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
                flexDirection: 'column-reverse',
                gap: theme.spacing(0.5),
                '& > *': {
                    width: '100%',
                    '&:not(first-of-type)': {
                        marginLeft: '0 !important',
                    }
                }
            },
        }
    };
};
